import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import {
    type MutationResolvers,
    UpdateAgentContactDocument as mutation,
    type UpdateAgentContactMutation,
} from '../generated/graphql'

const updateContactResolver: MutationResolvers<ApolloResolverContext>['updateContact'] = async (
    _root,
    { id, input },
    { client },
) => {
    if (!client) {
        throw new Error('Missing ApolloClient')
    }

    const updateAgentContact = {
        id,
        agentId: input.agentId,
        contactedAt: input.contactedAt,
        followUpUserId: input.followUpUserId,
        followUpDate: input.followUpDate,
        completedAt: input.completedAt,
        completedBy: input.completedBy,
        typeCode: input.typeCode,
        statusCode: input.statusCode,
        note: input.note,
        __typename: 'Contact' as const,
    }

    const res = await client.mutate<UpdateAgentContactMutation>({
        mutation,
        variables: { id, ...input },
        optimisticResponse: { updateAgentContact },
        update: (store, fetchResult): void => {
            if (!fetchResult?.data?.updateAgentContact) {
                throw new Error('Missing updateAgentContact')
            }

            // update cached agent contact logs
            const updatedContact = fetchResult?.data?.updateAgentContact
            const { followUpUserId, followUpDate, completedAt, completedBy, typeCode, statusCode, note } =
                updatedContact
            store.writeData({
                data: {
                    followUpUserid: followUpUserId, // ES field
                    followUpUserId, // Edit field
                    followupAt: followUpDate, // ES field
                    followUpDate, // Edit field
                    completedAt,
                    completedBy,
                    typeCode,
                    statusCode,
                    note,
                },
                id: `SearchContactLog:${id}`,
            })
            store.writeData({
                data: {
                    followUpUserId,
                    followUpDate,
                    completedAt,
                    completedBy,
                    typeCode,
                    statusCode,
                    note,
                },
                id: `Contact:${id}`,
            })
        },
    })

    return res.data?.updateAgentContact || null
}

export default updateContactResolver
